// AssociateButton.tsx
import React from 'react';
import { Button } from '@fluentui/react-components';
import { Add16Regular } from '@fluentui/react-icons';

type AssociateButtonProps = {
  onClick: () => void;
};

const AssociateButton: React.FC<AssociateButtonProps> = ({ onClick }) => {
  return (
    <Button size="small" icon={<Add16Regular />} appearance="secondary" iconPosition="before" onClick={onClick}>
      Associate
    </Button>
  );
};

export default AssociateButton;
